
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './luis21.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pluis21 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {





  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id64c0853a9255464525641b77" >

      <div id="i55h" className="">
      
      <div id="i9y207" className="">
      
        <a
          target=""
          className=""
          id="in6s8w"
          href="#"
        >
          
        <a
          target=""
          className=""
          id="i0df2k"
          href={`/`}
        >
          
      <img
        className=""
        id="i9xdej"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkr0oo7y.png"
        alt="undefined"
      />
      
        </a>
        
        </a>
        
      <div
        id="i3hvmk"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
        <a
          target=""
          className=""
          id="ikstg9"
          href="#"
        >
          
      <div className="" id="itwukm">
        <>Quiénes Somos</>
      </div>
      
        </a>
        
        <a
          target=""
          className=""
          id="io3hkg"
          href={`/aprende`}
        >
          
      <div className="" id="iqgcr3">
        <>Aprende</>
      </div>
      
        </a>
        
        <a
          target=""
          className=""
          id="iu014u"
          href="/#ijf0dn"
        >
          
      <div className="" id="i0at8i">
        <>Preguntas  Frecuentes</>
      </div>
      
        </a>
        
        <a
          target=""
          className=""
          id="i8466w"
          href="/#ijn4q"
        >
          
      <div className="" id="i7nvgl">
        <>Contáctanos</>
      </div>
      
        </a>
        
      </div>
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/quienessomos"
        type=""
      >
        <>Quienes Somos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/aprende"
        type=""
      >
        <>Aprende</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/#ijf0dn"
        type=""
      >
        <>Preguntas Frecuentes</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/#ijn4q"
        type=""
      >
        <>Contáctanos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="it53zo" className="">
      
      <div className="" id="idy4ul">
        
      <i className="" id="i9y65i">
        <>"Nuestra experiencia en el sector bancario revela que el conocimiento financiero y las decisiones de inversión están concentradas en un pequeño grupo de personas. Aunque se han hecho esfuerzos para democratizar este conocimiento, su alcance sigue siendo limitado debido a la alta especialización requerida. Con Treasury Tool, buscamos brindar a más personas acceso a mejores condiciones para sus recursos. Nuestra herramienta facilitará el ingreso seguro al mercado financiero, con el apoyo de expertos, con el fin de maximizar la rentabilidad de nuestros usuarios"</>
      </i>
      
      </div>
      
      </div>
      
      <div id="ifxad2" className="">
      
      <div id="ijzglu" className="">
      
      <div id="i02zgu" className="">
      
      <div className="" id="i756yj">
        <>Khristian Madrid</>
      </div>
      
      <div className="" id="i85fx9">
        <>Director Ejecutivo</>
      </div>
      
      </div>
      
      <div id="igha0c" className="">
      
      <img
        className=""
        id="i5l6db"
        src="https://assetsprojects.s3.amazonaws.com/405opfilksfinhv.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="ik1axz"
          href="https://www.linkedin.com/in/khristianmadrid/"
        >
          
      <img
        className=""
        id="itfhdn"
        src="https://assetsprojects.s3.amazonaws.com/405opfilksgiyd3.png"
        alt="undefined"
      />
      
      <div className="" id="ic6j9l">
        
      <b className="" id="i7rfj">
        <>+ 10 años de experiencia en Finanzas</>
      </b>
      
      </div>
      
        </a>
        
      <div className="" id="ibmtil">
        <>Amplia experiencia en la aplicación de productos  financieros en las empresas del sector real, a través del uso de tecnología.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Tuve la oportunidad de administrar y maximizar la rentabilidad de la liquidez en uno de los mayores fondos de infraestructura del país.</>
      <br className="" id="" />
      
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i6qevj" className="">
      
      <div id="i0gntp" className="">
      
      <div className="" id="i3cf8h">
        <>Luis Murcia</>
      </div>
      
      <div className="" id="ijgv07">
        <>Director Producto</>
      </div>
      
      </div>
      
      <div id="ibexwq" className="">
      
      <img
        className=""
        id="i9snf3"
        src="https://assetsprojects.s3.amazonaws.com/405opfilksfh027.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="i3n0h5"
          href="https://www.linkedin.com/in/Luismurcia1022/"
        >
          
      <img
        className=""
        id="iud3za"
        src="https://assetsprojects.s3.amazonaws.com/405opfilksgiyd3.png"
        alt="undefined"
      />
      
      <div className="" id="ilpxzg">
        
      <b className="" id="ipczqv">
        <>+ 8 años de experiencia en Banca</>
      </b>
      
      </div>
      
        </a>
        
      <div className="" id="ie6ulm">
        <>Economista y analista de datos, con experiencia en el diseño e implementación de modelos para la gestión de inversiones y riesgos financieros.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>A través de mi experiencia me he dado cuenta el valor que tienen los datos para la toma de decisiones, por eso a través de TRET quiero poner al servicio del mayor número de personas este conocimiento.</>
      <br className="" id="" />
      
      <br className="" id="" />
      
      <br className="" id="" />
      
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i50v8w" className="">
      
      <div id="ih2rx9" className="">
      
      <div className="" id="ik7mdw">
        <>Adip Numa</>
      </div>
      
      <div className="" id="iiqv1z">
        <>Director Financiero</>
      </div>
      
      </div>
      
      <div id="i93zjf" className="">
      
      <img
        className=""
        id="icdyo6"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkubatbw.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="iimp5t"
          href="https://www.linkedin.com/in/adip-numa-hellal-08022312/"
        >
          
      <img
        className=""
        id="itr4rg"
        src="https://assetsprojects.s3.amazonaws.com/405opfilksgiyd3.png"
        alt="undefined"
      />
      
      <div className="" id="iunisf">
        
      <b className="" id="ic84al">
        <>+ 20 años de experiencia en Banca</>
      </b>
      
      </div>
      
        </a>
        
      <div className="" id="ipds6f">
        <>Soy Economista de profesión con más de 20 años de experiencia liderando tesorerías, lo que me ha brindado un profundo conocimiento sobre el manejo de la liquidez y el flujo de caja. A lo largo de mi trayectoria, he negociado diversos productos de los mercados financieros.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>He sido responsable de la implementación exitosa de herramientas tecnológicas para la gestión de tesorería y he llevado a producción nuevos productos del mercado de capitales. Estoy comprometido con el crecimiento y la innovación, siempre buscando oportunidades para mejorar y optimizar las operaciones financieras.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i5of" className="">
      
      <div id="i8lmjf" className="">
      
      <div id="im4a28" className="">
      
      <img
        className=""
        id="iteqmg"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkr5bykb.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iqpkke" className="">
      
      <div className="" id="iy8adh">
        <>Dirección</>
      </div>
      
      <div className="" id="iiauur">
        <>Bogotá, Colombia</>
      </div>
      
      </div>
      
      <div id="imh7h6" className="">
      
      <div className="" id="ijoril">
        <>Correo de contacto</>
      </div>
      
      <div className="" id="ik2c1u">
        <>info@tret.com.co</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iw4n9w" className="">
      
      <div id="ianz3m" className="">
      
      </div>
      
      <div id="iufalf" className="">
      
      <div className="" id="ij1xap">
        <>Coyright©2023 TRET - Todos los derechos reservados.</>
      </div>
      
      <div id="ielirh" className="">
      
      <img
        className=""
        id="ii3z3k"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk14hfve.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="irlz65"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk14i6xh.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="it3ooa"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk14iokp.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pluis21);
  